import React from "react";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import APIService from "../../Service/APIService";
import { Button, Form, Input, Row, Col, Modal } from "antd";
import Select from "react-select";
import Swal from "sweetalert2";
import { colors } from "../../theme/colors.js";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import SectionHeader from "../../common/section-header/index.js";
import NewProviderModal from "../DirectOrder/Procedures/NewProviderModal.js";

const AccountUsers = (props) => {
  const { user, isReady } = useAuth();
  const userData = user;
  const { accountData } = props;
  const readOnly = props.readOnly === true;
  const [accountUsers, setAccountUsers] = React.useState([]);
  const [selectedAccount, setSelectedAccount] = React.useState(accountData?.ID);
  const [prefix, setPrefix] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [formattedUsers, setFormattedUsers] = React.useState([]);
  const [showLoader, setShowLoader] = React.useState(false);
  const [loading, setLoading] = React.useState(true);
  const [providerModalVisible, setProviderModalVisible] = React.useState(false);
  const canManageAccountUsers =
    userData?.Type === "Admin" &&
    hasPermission(userData, "manage_accounts.edit") &&
    !readOnly;

  const getAllAccountUsers = async () => {
    if (accountData && accountData?.ID) {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        `getaccountusersbyaccount?AccountID=${accountData.ID}`
      );
      console.log("Account Users: ", response);
      return response?.data?.data;
    }
  };
  const [modalUserVisible, setModalUserVisible] = React.useState(false);

  const handleModalOk = () => {
    setModalUserVisible(false);
  };
  const handleModalCancel = () => {
    setModalUserVisible(false);
  };

  const handleUserNew = () => {
    if (readOnly) return;
    setModalUserVisible(true);
  };

  const addAccountUser = async () => {
    if (readOnly) return;
    const normalizedEmail = email.trim();
    let isValidate = true;
    if (!firstName || !lastName || !phone) {
      isValidate = false;
    }
    if (!isValidate) {
      Swal.fire({
        title: "Error!",
        text: "Please fill the required fields",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this contact to this account?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setModalUserVisible(false);
        setShowLoader(true);
        const postObj = {
          AccountID: accountData?.ID,
          AccountName: accountData?.AccountName,
          Prefix: prefix,
          FirstName: firstName,
          LastName: lastName,
          Phone: phone,
          Active: true,
          Type: "Account",
          SendMail: false,
        };
        if (normalizedEmail) {
          postObj.Email = normalizedEmail;
        }
        console.log("Post Object: ", postObj);
        const serv = new APIService();
        try {
          const response = await serv.addDataToBackend(postObj, "register");
          console.log("Response: ", response);
          if (response?.status === 200 || response?.status === 201) {
            Swal.fire({
              icon: "success",
              title: "Contact Added",
              text: "Contact has been added successfully",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed to add contact",
              text: "Error while adding contact. This email might already exist. Please verify and try again.",
            });
          }
        } catch (error) {
          console.error("Register API failed:", error);
          const errorMessage =
            error?.response?.data?.message ||
            "Error while adding contact. This email might already exist. Please verify and try again.";
          Swal.fire({
            icon: "error",
            title: "Failed to add contact",
            text: errorMessage,
          });
        } finally {
          setShowLoader(false);
        }
      }
    });
  };

  React.useEffect(() => {
    // console.log("Account Users component mounted");
    // console.log("AccData: ", accountData);
    getAllAccountUsers().then((data) => {
      console.log("Account Users: ", data);
      if (data?.length > 0) {
        setFormattedUsers(
          data.map((ele) => ({
            ...ele,
            Name: `${ele.FirstName} ${ele.LastName}`,
            Role: (
              <Button
                // type={ele.RoleType === 'Account' ? 'primary' : 'primary'}
                type="primary"
                shape="round"
                size="small"
                style={{
                  color:
                    ele.RoleType === "Account"
                      ? colors["primaryColor"]
                      : ele.RoleType === "Provider"
                      ? colors["primaryColor"]
                      : "#ff9202",
                  borderColor:
                    ele.RoleType === "Account"
                      ? colors["primaryColor"]
                      : ele.RoleType === "Provider"
                      ? colors["primaryColor"]
                      : "#ff9202",
                  background:
                    ele.RoleType === "Account" ? "transparent" : "transparent",
                  width: "100%",
                }}
              >
                {ele.RoleType === "Account"
                  ? "TV User"
                  : ele.RoleType === "Provider"
                  ? "Provider"
                  : "Contact"}
              </Button>
            ),
            Options: <span>-</span>,
          }))
        );
      }

      setAccountUsers(data);
    }).finally(() => setLoading(false));
  }, []);
  return (
    <div>
      {showLoader && (
        <Spin
          fullscreen
          indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
        />
      )}
      <SectionHeader
        title="Account Users"
        showButton={false}
        rightContent={
          canManageAccountUsers ? (
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                type="button"
                className="section-header-button"
                onClick={handleUserNew}
              >
                + Add Contact
              </button>
              <button
                type="button"
                className="section-header-button"
                onClick={() => setProviderModalVisible(true)}
              >
                + Add Provider
              </button>
            </div>
          ) : null
        }
      />
      <GenericDashboard
        data={formattedUsers}
        screen="AccountUsers"
        loading={loading}
      />
      {!readOnly && <Modal
        title="Add New Account User"
        open={modalUserVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        centered={true}
        footer={null}
        style={{ width: "1000px" }}
      >
        <div>
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Account">
                  <Select
                    defaultValue={{
                      label: `${accountData?.AccountName}`,
                      value: `${accountData?.ID}`,
                    }}
                    value={{
                      label: `${accountData?.AccountName}`,
                      value: `${accountData?.ID}`,
                    }}
                    // onChange={(e) => setSelectedAccount(e.value)}
                    // options={[
                    //   { label: `${accountData?.AccountName}`, value: `${accountData?.ID}` },
                    //   { value: 'account1', label: 'Account 1' },
                    //   { value: 'account2', label: 'Account 2' },
                    //   { value: 'account3', label: 'Account 3' },
                    // ]}
                    isDisabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item label="Prefix">
                  <Input
                    placeholder="Dr."
                    onChange={(e) => setPrefix(e.target.value)}
                    value={prefix}
                  />
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#616161",
                    }}
                  >
                    Optional
                  </p>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="First Name">
                  <Input
                    placeholder="Enter First Name"
                    onChange={(e) => setFirstName(e.target.value)}
                    value={firstName}
                  />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="Last Name">
                  <Input
                    placeholder="Enter Last Name"
                    onChange={(e) => setLastName(e.target.value)}
                    value={lastName}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row
              gutter={16}
              style={{ marginTop: "-15px", marginBottom: "-10px" }}
            >
              <Col span={10}>
                <Form.Item label="Email">
                  <Input
                    placeholder="Enter Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                  <p
                    style={{
                      fontSize: "12px",
                      fontWeight: "500",
                      color: "#616161",
                    }}
                  >
                    Optional
                  </p>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item label="Phone">
                  <Input
                    placeholder="Enter Phone"
                    onChange={(e) => setPhone(e.target.value)}
                    value={phone}
                  />
                </Form.Item>
              </Col>
            </Row>
            <p
              style={{
                fontSize: "16px",
                fontWeight: "400",
                color: "#2d2d2d",
              }}
            >
              Adding a contact does not give them access to Tissue Vault.
              Manage invitations and portal access from the unified Users page.
            </p>
            <Button
              type="primary"
              style={{ background: "#27a907" }}
              onClick={addAccountUser}
            >
              Add Contact
            </Button>
            {/* <p style={{ fontSize: '16px', fontWeight: '400', color: '#2d2d2d' }}>OR</p> */}
            {/* <Button type='primary' style={{ background: '#27a907' }}>Add Contact and Activate</Button> */}
          </Form>
        </div>
      </Modal>}
      {canManageAccountUsers && (
        <NewProviderModal
          isOpen={providerModalVisible}
          onClose={() => setProviderModalVisible(false)}
          accountID={accountData?.ID}
          onProviderCreated={() => window.location.reload()}
        />
      )}
    </div>
  );
};

export default AccountUsers;
